<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center px-4 py-8">
    <div class="max-w-5xl w-full">
      <!-- Header Section -->
      <div class="text-center mb-16">
        <h1 class="text-5xl md:text-6xl font-extrabold text-white mb-4 animate-fade-in-down">
          Welcome to the <span class="text-yellow-300">Charge Health Admin Portal</span>
        </h1>
      </div>

      <!-- Navigation Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div
            v-for="item in navigationItems"
            :key="item.title"
            @click="goToRoute(item.route)"
            class="cursor-pointer transform hover:scale-105 transition-transform duration-300 animate-fade-in"
        >
          <div class="relative bg-white rounded-lg shadow-lg overflow-hidden flex flex-col h-full">
            <!-- Image Section -->
            <div
                class="h-48 bg-cover bg-center flex-shrink-0"
                :style="{ backgroundImage: `url(${item.image})` }"
            >
              <div class="absolute inset-0 bg-black bg-opacity-25 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                <component :is="item.icon" class="h-16 w-16 text-white"></component>
              </div>
            </div>
            <!-- Content Section -->
            <div class="p-6 flex flex-col flex-grow">
              <h2 class="text-2xl font-bold mb-2 text-gray-800">{{ item.title }}</h2>
              <p class="text-gray-600 flex-grow">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="mt-16 text-center text-gray-200">
        &copy; {{ new Date().getFullYear() }} Charge Health, Inc. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
// Import HeroIcons v2 icons
import {UsersIcon, BuildingOffice2Icon, ChartBarIcon} from '@heroicons/vue/24/outline';


export default {
  name: 'LandingPage',
  data() {
    return {
      navigationItems: [
        {
          title: 'Manage Nurses',
          description: 'Review, edit, and remove nurses.',
          route: '/users',
          image: require('@/assets/users.jpg'),
          icon: UsersIcon,
        },
        {
          title: 'Manage Hospitals',
          description: 'Update hospitals.',
          route: '/sites',
          image: require('@/assets/sites.jpg'),
          icon: BuildingOffice2Icon,
        },
        {
          title: 'Schedule Reports',
          description: 'Create and manage recurring reports.',
          route: '/reports',
          image: require('@/assets/reports.jpg'),
          icon: ChartBarIcon,
        },
      ],
    };
  },
  methods: {
    goToRoute(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
/* Animations */
@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in-down {
  animation: fade-in-down 1s ease-out;
}

.animate-fade-in {
  animation: fade-in 1s ease-out;
}
</style>
